
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface CompanyInfoProps {
  name: string;
  onChange: (key: string, value: string) => void;
}

export const CompanyInfoSection = ({ name, onChange }: CompanyInfoProps) => {
  return (
    <div>
      <Label htmlFor="company-name" className="text-base font-semibold">
        Company Information
      </Label>
      <div className="mt-2">
        <Label htmlFor="company-name" className="text-sm">
          Company Name <span className="text-red-500">*</span>
        </Label>
        <Input 
          id="company-name"
          value={name}
          onChange={(e) => onChange("name", e.target.value)}
          className="mt-1"
        />
      </div>
    </div>
  );
};
